import fp from 'lodash/fp';
import React, { FC } from 'react';

import styles from './index.module.scss';


export type GradientPlaceholderProps = {
    seed?: number;
    length: number | [number, number];
};

const seededRandom = (seed: number, from: number, to: number) => {
    const x = Math.sin(seed) * 10000;
    return to + (from - to) * (x - Math.floor(x));
};

const generateNonWhitespace = fp.repeat(fp.__, '_');

export const GradientPlaceholder: FC<GradientPlaceholderProps> = React.memo(
    ({ length, seed }) => (
        <span className={styles.gradientPlaceholder}>
            {generateNonWhitespace(
                fp.isArray(length)
                    ? seed
                        ? seededRandom(seed, ...length)
                        : fp.random(...length)
                    : length,
            )}
        </span>
    ),
);
